import { getAdminNotification } from './action/auth';

// Action types
const GET_PROFILE_REQUEST = 'GET_PROFILE_REQUEST';
const GET_PROFILE_SUCCESS = 'GET_PROFILE_SUCCESS';
const GET_PROFILE_FAILURE = 'GET_PROFILE_FAILURE';
const GET_EMPLOYEE_DATA = 'GET_EMPLOYEE_DATA';
const GET_MINE_DATA = 'GET_MINE_DATA';
const GET_STATES_REQUEST = 'GET_STATES_REQUEST'; // New action type
const GET_STATES_SUCCESS = 'GET_STATES_SUCCESS'; // New action type
const GET_STATES_FAILURE = 'GET_STATES_FAILURE'; // New action type

const GET_ACTIVITY_POINTS_SUCCESS = 'GET_POINST_SUCCESS';
const GET_POINTS_HISTORY_SUCCESS = 'GET_POINST_HISTORY_SUCCESS';

const GET_LEAD_SUCCESS = 'GET_MY_LEAD_SUCCESS';
const GET_REQUEST_VEHICLE_STATE = 'GET_REQUEST_VEHICLE_STATE';
const GET_POLICY_BY_STATUS = 'GET_POLICY_BY_STATUS';
const GET_POLICY_BY_STAGE_AND_STATUS = 'GET_POLICY_BY_STAGE_AND_STATUS';
const GET_USER_LIST = 'GET_USER_LIST';
const GET_COMPANY_LIST = 'GET_COMPANY_LIST';
const GET_ALL_REQUEST_BYID = 'GET_ALL_REQUEST_BYID';
const GET_COMPANY_DATA = 'GET_COMPANY_DATA';
const GET_ALL_REQUEST_LIST = 'GET_ALL_REQUEST_LIST';
const GET_ADMIN_NOTIFICATION = 'GET_ADMIN_NOTIFICATION';
const GET_USER_NOTIFICATION = 'GET_USER_NOTIFICATION';
const GET_ADMIN_UNREAD_NOTIFICATION = 'GET_ADMIN_UNREAD_NOTIFICATION';
const GET_USERS_ACTIVITY = 'GET_USERS_ACTIVITY';
const GET_REQUEST_STATE = 'GET_REQUEST_STATE';
const GET_REQUEST_STATE_BY_STATUS = 'GET_REQUEST_STATE_BY_STATUS';
const GET_ALL_LEAD_SUCCESS = 'GET_ALL_LEAD_SUCCESS';
// Initial state
const initialState = {
  requestStats: {},
  leads: [],
  pointsHistory: [],
  userslist: [],
  requestById: {},
  allRequestList: [],
  activityPoints: {},
  requestVehicleStat: [],
  policy: [],
  requestByStatus: [],
  states: {},
  employee: [],
  profile: null,
  loading: false,
  error: '',
  linkSent: false,
  companyList: [],
  getAdminNotify: [],
  adminUnReadNotification: [],
  getUserNotify: [],
  companyData: [],
  mineData: {},
  userActivityData: [],
  requestByStatus: [],
  paidRequests: [],
};

// Reducer
const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_LEAD_SUCCESS:
      return { ...state, loading: true, paidRequests: action.payload };
    case GET_REQUEST_STATE_BY_STATUS:
      return { ...state, loading: true, requestByStatus: action.payload };
    case GET_REQUEST_STATE:
      return { ...state, loading: true, requestStats: action.payload };
    case GET_USERS_ACTIVITY:
      return { ...state, loading: true, userActivityData: action.payload };
    case GET_MINE_DATA:
      return { ...state, loading: true, mineData: action.payload };
    case GET_COMPANY_DATA:
      return { ...state, loading: true, companyData: action.payload };
    case GET_ADMIN_UNREAD_NOTIFICATION:
      return {
        ...state,
        loading: true,
        adminUnReadNotification: action.payload,
      };
    case GET_USER_NOTIFICATION:
      return { ...state, loading: true, getUserNotify: action.payload };
    case GET_ADMIN_NOTIFICATION:
      return { ...state, loading: true, getAdminNotify: action.payload };
    case GET_COMPANY_LIST:
      return { ...state, loading: true, companyList: action.payload };
    case GET_ALL_REQUEST_BYID:
      return { ...state, loading: true, requestById: action.payload };
    case GET_ALL_REQUEST_LIST:
      return { ...state, loading: true, allRequestList: action.payload };
    case GET_PROFILE_REQUEST:
      return { ...state, loading: true, error: '' };
    case GET_PROFILE_SUCCESS:
      return { ...state, loading: false, profile: action.payload };
    case GET_USER_LIST:
      return { ...state, loading: false, userslist: action.payload };
    case 'UPDATE_QUOTATION_DETAILS':
      return { ...state, quotationDetail: action.payload };
    case GET_EMPLOYEE_DATA:
      return { ...state, loading: false, employee: action.payload };
    case GET_POLICY_BY_STATUS:
      return { ...state, loading: false, policy: action.payload };
    case GET_POLICY_BY_STAGE_AND_STATUS:
      return { ...state, loading: false, requestByStatus: action.payload };
    case GET_REQUEST_VEHICLE_STATE:
      return { ...state, loading: false, requestVehicleStat: action.payload };
    case GET_PROFILE_FAILURE:
      return { ...state, loading: false, error: action.payload };
    // New cases for fetching states
    case GET_STATES_REQUEST:
      return { ...state, loading: true, error: '' };

    case GET_STATES_SUCCESS:
      return { ...state, loading: false, states: action.payload };

    case GET_STATES_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case GET_ACTIVITY_POINTS_SUCCESS:
      return { ...state, loading: false, activityPoints: action.payload };
    case GET_POINTS_HISTORY_SUCCESS:
      return { ...state, loading: false, pointsHistory: action.payload };
    case GET_LEAD_SUCCESS:
      return { ...state, loading: false, leads: action.payload };
    case 'FETCH_VEHICLE_REQUESTS_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_VEHICLE_REQUESTS_SUCCESS':
      return { ...state, loading: false, data: action.payload };
    case 'FETCH_VEHICLE_REQUESTS_FAILURE':
      return { ...state, loading: false, error: action.payload };
    case 'FETCH_STATUS_BY_YEARS_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_STATUS_BY_YEARS_SUCCESS':
      return { ...state, loading: false, data: action.payload };
    case 'FETCH_STATUS_BY_YEARS_FAILURE':
      return { ...state, loading: false, error: action.payload };
    case 'FETCH_STAGEWISE_TOTAL_REQUEST_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_STAGEWISE_TOTAL_REQUEST_SUCCESS':
      return { ...state, loading: false, data: action.payload };
    case 'FETCH_STAGEWISE_TOTAL_REQUEST_FAILURE':
      return { ...state, loading: false, error: action.payload };

    case 'DELETE_LEAD_SUCCESS':
      return {
        ...state,
        leads: state.leads.filter((lead) => lead.id !== action.payload),
      };

    default:
      return state;
  }
};

export default authReducer;
